import { SocialLoginOption } from "@redotech/redo-model/auth/social-auth";
import { Step } from "@redotech/redo-model/return-flow";
import { ReturnOptionMethod } from "@redotech/redo-model/return-flow/return-option";
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { SettingsContext } from "../contexts/settings";
import {
  getHeaderText,
  getLoginGiftText,
  getWarrantyText,
} from "./dynamic-text-utils";
export interface UseOneTimePasscodeResponse {
  texts: {
    title: string;
    subtitle: string;
    merchantName: string;
    giftButton: string;
    registerButton: string;
    emailButton: string;
  };
  logo: string;
  onBack: (() => void) | undefined;
  hideGiftOption: boolean;
  registrationEnabled: boolean;
  socialLoginOptions: SocialLoginOption[] | undefined;
  isGiftReceiptLogin: boolean;
}

export function useLandingPage({
  onBack,
}: {
  onBack?: () => void;
}): UseOneTimePasscodeResponse {
  const settings = useContext(SettingsContext);
  const [params] = useSearchParams();
  const isCreateGiftReturnLink =
    params.get("create_gift_return_link") !== null &&
    !!settings?.returns?.enableGiftReceipts;

  // If the merchant only offers returns for refund then we should hide the option for returning a gift,
  // since gift returns cannot be returned for refund.
  let hideGiftOption = true;
  if (
    settings?.packageProtection?.enabled &&
    settings.packageProtection.customerClaimsEnabled &&
    !settings.hideGiftOption
  ) {
    hideGiftOption = false;
  }
  if (settings?.returns?.enabled && hideGiftOption) {
    const returnOptionSteps = settings.returnFlow.steps.filter(
      (step) => step.type === Step.RETURN,
    );
    for (const returnOptionStep of returnOptionSteps) {
      for (const option of returnOptionStep.options) {
        if (option.method.type !== ReturnOptionMethod.REFUND) {
          hideGiftOption = false;
        }
      }
    }
  }

  return {
    texts: {
      title: getHeaderText(settings, isCreateGiftReturnLink),
      subtitle: isCreateGiftReturnLink
        ? "Find your order to create or manage gift receipts."
        : "Enter your email/zip and order or tracking number to login",
      merchantName: settings?.merchantName || "Unknown Merchant",
      giftButton: getLoginGiftText(settings),
      registerButton: getWarrantyText(settings),
      emailButton: "Sign in with email",
    },

    logo: settings?.theme.logo_image || "",

    hideGiftOption,
    registrationEnabled: settings?.warranties?.registrationEnabled || false,
    socialLoginOptions: settings?.theme?.socialLoginOptions,
    onBack,
    isGiftReceiptLogin: isCreateGiftReturnLink,
  };
}
